import { CommandName } from './CommandViewModel';

export type CommandsNameKeyMap = Record<string, CommandName>;

export const ModifierDictionary = {
  altKey: 'Alt',
  ctrlKey: 'Ctrl',
  metaKey: 'Meta',
  shiftKey: 'Shift',
} as const;
